export default __webpack_public_path__ + "static/media/office1-before2-1920w.900d40e1.webp";